// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"112": "aababda2","116": "4a41f847","122": "21a578a4","354": "9c6094ad","535": "1b822dcb","602": "d2d8a01f","783": "76f7ceb9",}[chunkId] + ".js"
}